import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Slide,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import MDButton from "components/MDButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export const DialogBox = ({
  title,
  description,
  handleSave,
  status,
  setStatus,
  handleDontSave,
}) => {
  const handleClose = () => {
    setStatus(false);
  };

  return (
    <Dialog
      open={status}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
    >
      <Grid sx={{ paddingX: "25px" }}>
        <DialogTitle
          style={{
            color: "black",
            fontFamily: "Montserrat",
            textAlign: "center",
          }}
        >
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#000000",
          }}
        >
          <Close />
        </IconButton>
        <Divider />
        <DialogContent style={{ maxWidth: "350px" }}>
          <DialogContentText
            id="alert-dialog-slide-description"
            style={{ color: "black", fontFamily: "Montserrat", textAlign: "center" }}
          >
            {description}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <MDButton
            variant="outlined"
            style={{
              backgroundColor: "white",
              color: "black",
              fontFamily: "Montserrat",
              borderRadius: "50px",
              border: "1px solid black",
              width: "50%",
            }}
            onClick={handleDontSave}
          >
            Don't Save
          </MDButton>
          <MDButton
            variant="contained"
            style={{
              backgroundColor: "black",
              color: "white",
              fontFamily: "Montserrat",
              borderRadius: "50px",
              width: "50%",
            }}
            onClick={() => {
              handleSave();
              handleClose();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Grid>
    </Dialog>
  );
};
